module.exports = __webpack_public_path__ + "static/deleting-81c9edf7b08d2d3aeef39f10bb5fb617.gif";